import { Component, OnInit } from '@angular/core';

import { NotificationService } from 'src/app/core/notification.service';
import { StrikeService } from 'src/app/core/strike.service';
import { StrikeDetails } from 'src/app/shared/interfaces/strike-details';


@Component({
  selector: 'app-all-strikes',
  templateUrl: './all-strikes.component.html',
  styleUrls: ['./all-strikes.component.css']
})
export class AllStrikesComponent implements OnInit {
  strikes: StrikeDetails = [];
  filterStrikes = '';
  page = 0;
  pageSize = 20;
  pagesCount = 0;

  constructor(
    private strikeService: StrikeService,
    private notificationService: NotificationService
  ) {}

  async ngOnInit() {
    this.search(0)
  }

  async search(page: number) {
    const config = {
      params: {
        page: page,
        pageSize: this.pageSize,
        filter: this.filterStrikes
      }
    }

    const strikes = await this.strikeService.getAllStrikes(config);

    if (strikes.Items.length) {
      this.strikes = strikes.Items
      this.page = strikes.Page
      this.pagesCount = strikes.TotalPages
    }
    else {
      this.notificationService.displayError('No strikes found')
    }
  }

  clearSearch() {
    this.filterStrikes = '';
    this.search(0);
  }
}
